<template>
  <div>
    <b-row>
      <b-col class="col-8">
        <b-text-input-validated
          label="Sub-Category"
          v-model="subCategory.name"
        />
      </b-col>
      <b-col class="col-3">
        <b-text-input-validated
          label="Shorthand"
          v-model="subCategory.abbreviation"
        />
      </b-col>
      <b-col class="col-1">
        <i class="fa fas fa-trash tsny_icon" @click="deleteSubcategory" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import BTextInputValidated from "../../FormInputs/BTextInputValidated";
export default {
  name: "SubCategory",
  components: { BTextInputValidated },
  props: {
    subCategory: {
      type: Object,
      default: null
    }
  },
  methods: {
    deleteSubcategory() {
      this.$emit("delete-subcategory");
    }
  }
};
</script>

<style scoped></style>
